import http from "../http-common";

class CustomerNotesService {
  getAll(customerId) {
    return http.get(`/customers/${customerId}/notes`);
  }

  create(customerId, data) {
    return http.post(`/customers/${customerId}/notes`, data);
  }

  update(customerId, noteId, data) {
    return http.put(`/customers/${customerId}/notes/${noteId}`, data);
  }

  remove(customerId, noteId) {
    return http.delete(`/customers/${customerId}/notes/${noteId}`);
  }
}

const customerNotesService = new CustomerNotesService();

export default customerNotesService;

